module.exports = {
  //region helpers
  Languages: {
    "pt-BR": {
      InvalidBodyMsgAlert: "Parâmetros incorretos para usar a função {showWndMsgAlert}. Por favor, você precisa de um JSON válido com -> {body}",
      InvalidArgs: "\"[args]\" não pode ser nulo ou indefinido.",
      AddValidToken: "Incluir um token válido ou credenciais para gerar um novo.",
      AnyFilterDefined: "Nenhum filtro foi definido corretamente.",
      InvalidgdIdEvent: "[gdIdEvent] Inválido.",
      NotAuthenticatedYet: "Você não se identificou. Crie um token pra você, clicando no menu <span class=\"glyphicon glyphicon-lock\" data-toggle=\"tooltip\" data-placement=\"bottom\"></span> para descobrir.",
      AuthenticationSuccess: ":) Autenticado!",
      AuthenticationError: ":( Erro de Autenticação.",
      PeriodMeasure: {
        second: "Segundo",
        minute: "Minuto",
        hour: "Hora",
        day: "Diário",
        week: "Semanal",
        mon: "Mensal",
        year: "Anual"
      },
      OperationStatus: {Done: "pronto", Unapproved: "reprovado", Waiting: "aguardando"},
      Sorry: "Desculpe! Algo de errado aconteceu e não foi possível completar a requisição. Tente novamente mais tarde. Obrigado.",
      DataBuy: "Comprar Dados",
      SummaryMain: "Resumo",
      UserAccountTitle: "Conta",
      UserCompanyTitle: "Empresa",
      CycleMain: "Ciclo",
      CycleIniTitle: "Início",
      CycleEndTitle: "Fim",
      CycleTypeTitle: "Tipo",
      CycleNumberTitle: "Número",
      DashIndicatorMain: "Indicadores",
      LeadTotalBayedTitle: "Total Acumulado",
      TotalLeadApprovedOverflowTitle: "Total Excedentes",
      LeadManagerSummarizedTitle: "Leads",
      WndLeadManagerTitle: "Gerenciador de Consumo de Dados",
      Wonderful: "Maravilha! Agora você acessar o gerenciador de leads e utilizar sua lista.",
      Transaction: "Transação: ",
      ChangeYourMind: "Se mudar de idéia essa lista pode ser aprovada no gerenciador de leads.",
      FailOnBuy: "Não foi possível processar sua compra.<br/>Por favor tente novamente.",
      Yes: "Sim",
      No: "Não",
      SuportEmail: "suporte@cognatis.com.br",
      dataAccessAlertTitle: "Atenção.",
      dataLeadDefaultMsgLock: "Olá {0} :).<br/> Esta transação excede a cota contratada de {1} registros acumulados no período de {2} à {3}.<br/>Por favor entre em contato com a Cognatis através do e-mail ({4}) ou telefone +55(11)3014-6200 para solicitar um aumento de pacote contratado.",
      dataLeadDefaultMsgPayperLead: "Olá {0} :).<br/>Essa transação excede a cota contratada de {1} registros acumulados no período: <br/>&nbsp;de: {2}<br/>até: {3}.<br/> Ao clicar no \"SIM\", você concorda com os custos adicionais estabelecidos nas atuais condições contratuais.<br/>Para solicitar um aumento no pacote contratado, entre em contato com a Cognatis por e-mail ({4}) ou telefone +55 (11) 3014-6200. <br><br> Novos registros na transação {5} <br> Acumulado sem a Transação {6} <br> Acumulado com a Transação {7} <br>"
    },
    "es-ES": {
      InvalidBodyMsgAlert: "Parámetros incorrectos para usar la función {showWndMsgAlert}. Necesitas un JSON válido con -> {body}",
      InvalidArgs: "\"[args]\" no puede ser nulo o indefinido.",
      AddValidToken: "Incluir un testigo válido o credenciales para generar uno nuevo.",
      AnyFilterDefined: "Ningún filtro se ha establecido correctamente.",
      InvalidgdIdEvent: "[gdIdEvent] Inválido.",
      NotAuthenticatedYet: "Usted no se Identificó. Crea un token para ti, haciendo clic en el menú <span class=\"glyphicon glyphicon-lock\" data-toggle=\"tooltip\" data-placement=\"bottom\"></span> para descubrir.",
      AuthenticationSuccess: ":) Autenticado!",
      AuthenticationError: ":( Error de Autenticación.",
      PeriodMeasure: {
        second: "Segundo",
        minute: "Minuto",
        hour: "Hora",
        day: "Diario",
        week: "Semanal",
        mon: "Mensual",
        year: "Anual"
      },
      OperationStatus: {Done: "hecho", Unapproved: "obsoleta", Waiting: "en espera"},
      Sorry: "¡Me disculpa! Algo incorrecto ocurrió y no fue posible completar la petición. Inténtelo de nuevo más tarde. Gracias.",
      DataBuy: "Comprar Datos",
      SummaryMain: "Resumen",
      UserAccountTitle: "Cuenta",
      UserCompanyTitle: "Compañía",
      CycleMain: "Ciclo",
      CycleIniTitle: "Inicio",
      CycleEndTitle: "Fin",
      CycleTypeTitle: "Tipo",
      CycleNumberTitle: "No",
      DashIndicatorMain: "Indicadores",
      LeadTotalBayedTitle: "Total acumulado",
      TotalLeadApprovedOverflowTitle: "Total Excedentes",
      LeadManagerSummarizedTitle: "Leads",
      WndLeadManagerTitle: "Administrador de Consumo de Datos",
      Wonderful: "Wonder! Ahora accede al gestor de leads y utilizará su lista",
      Transaction: "Transacción: ",
      ChangeYourMind: "Si cambia de idea, esta lista puede ser aprobada en el gestor de leads.",
      FailOnBuy: "No fue posible procesar su compra.<br/>Por favor inténtelo de nuevo.",
      Yes: "Sí",
      No: "No",
      SuportEmail: "suporte@cognatis.com.br",
      dataAccessAlertTitle: "Atención.",
      dataLeadDefaultMsgLock: "Hola {0} :). Esta transacción excede la cuota contratada de {1} registros acumulados en el período de {2} a {3}. Para solicitar un paquete de una mayor contratado por favor póngase en contacto con el Cognatis por correo electrónico ({4}) o teléfono +55(11)3014-6200.",
      dataLeadDefaultMsgPayperLead: "Hola, {0} :). Esta transacción excede la cuota contratada de {1} registros acumulados en el período:<br/> {2} até {3}. Al hacer clic en \"SÍ\", acepta los costos adicionales establecidos en las condiciones contractuales actuales. Para solicitar un aumento en el paquete contratado, comuníquese con Cognatis por correo electrónico ({4}) o por teléfono +55 (11) 3014-6200. <br><br> Nuevos registros en la transacción {5} <br> Acumulados sin la transacción {6} <br> Acumulados con la transacción {7} <br>"
    },
    "en-US": {
      InvalidBodyMsgAlert: "Incorrect parameters to use function {showWndMsgAlert}. Please you need a valid JSON with -> {body}",
      InvalidArgs: "\"[args]\" can not be null or undefined.",
      AddValidToken: "Add a valid token or credentials to generate a new one.",
      AnyFilterDefined: "No filter was set correctly.",
      InvalidgdIdEvent: "[gdIdEvent] Invalid.",
      NotAuthenticatedYet: "you did not identify create a token for you by clicking on the <span class=\"glyphicon glyphicon-lock\" data-toggle=\"tooltip\" data-placement=\"bottom\"></span> menu to find out.",
      AuthenticationSuccess: ":) Authenticated!",
      AuthenticationError: ":( Authentication Error.",
      PeriodMeasure: {
        second: "Second",
        minute: "Minute",
        hour: "Hour",
        day: "Diary",
        week: "Weekly",
        mon: "Monthly",
        year: "Annual"
      },
      OperationStatus: {Done: "done", Unapproved: "unapproved", Waiting: "waiting"},
      Sorry: "I'm Sorry :(. Something wrong happened and the request could not be completed. Try again later. Thank you.",
      DataBuy: "Data Buy",
      SummaryMain: "Summary",
      UserAccountTitle: "Account",
      UserCompanyTitle: "Company",
      CycleMain: "Cycle",
      CycleIniTitle: "Start",
      CycleEndTitle: "End",
      CycleTypeTitle: "Type",
      CycleNumberTitle: "Number",
      DashIndicatorMain: "Indicators",
      LeadTotalBayedTitle: "Accumulated Total",
      TotalLeadApprovedOverflowTitle: "Total Surplus",
      LeadManagerSummarizedTitle: "Leads",
      WndLeadManagerTitle: "Data Consumption Manager",
      Wonderful: "Wonderful! Now you access the lead manager and use your list",
      Transaction: "Transaction: ",
      ChangeYourMind: "If you change your mind this list can be approved by the lead manager.",
      FailOnBuy: "We were unable to process your purchase.<br/>Please try again.",
      Yes: "Yes",
      No: "No",
      SuportEmail: "suporte@cognatis.com.br",
      dataAccessAlertTitle: "Attention.",
      dataLeadDefaultMsgLock: "Hello {0} :). This transaction exceeds the contracted quota of {1} records accumulated in the period from {2} to {3}. To request a hired package increase please contact Cognatis via email ({4}) or telephone +55(11)3014-6200.",
      dataLeadDefaultMsgPayperLead: "Hello {0} :). This transaction exceeds the contracted quota of {1} records accumulated in the period from: <br/>{2} to {3}. By clicking on the \"YES\" you agree to the additional costs established in the current contractual conditions. To request an increase in the contracted package, contact Cognatis by email ({4}) or telephone +55 (11) 3014-6200.<br><br>New Records in Transaction {5}<br>Accumulated without this Transaction {6}<br>Accumulated with this Transaction {7}<br>"
    }
  },
  Queries: {
    "Lead": {
      DataHeader:
        "select to_json(r) from (select \"en\".\"nId\", \"en\".\"cClientTag\", \"cl\".\"cMeasure\", generate_series(\"cl\".\"nQuantity\",\"pr\".\"nQuantity\") \"nCycleNumber\", \"pr\".\"dtStartIn\", \"pr\".\"dtFinishIn\", \"pr\".\"dtStartIn\" + (generate_series(\"cl\".\"nQuantity\",\"pr\".\"nQuantity\") || cl.\"cMeasure\")::interval - (\"cl\".\"nQuantity\" || cl.\"cMeasure\")::interval \"dtStartInCycle\", \"pr\".\"dtStartIn\" + (generate_series(\"cl\".\"nQuantity\",\"pr\".\"nQuantity\") || \"cl\".\"cMeasure\")::interval \"dtFinishInCycle\", justify_interval((generate_series(\"cl\".\"nQuantity\",\"pr\".\"nQuantity\") || \"cl\".\"cMeasure\")::interval) \"ivCycles\" from \"default\".\"tbPeriod\" \"pr\" inner join \"default\".\"tbEnvironment\" \"en\" on \"pr\".\"nIdEnvironment\" = \"en\".\"nId\" inner join \"default\".\"tbRecycle\" \"cl\" on \"cl\".\"nIdEnvironment\" = \"en\".\"nId\" where \"en\".\"cClientTag\" ~ '{0}' order by \"en\".\"cClientTag\", \"dtStartInCycle\",\"dtFinishInCycle\") as r where now() between \"dtStartInCycle\" and \"dtFinishInCycle\";",
      DataSet:
      "select json_agg(r) from (select round(coalesce(gp2.\"nChunkAdd\" / gp2.\"nCountChunkWorker\", 0) * 100) \"nProgress\", case \"bConfirm\" when true then (case gp3.\"bSnapshot\" when true then 'Done' else 'Waiting' end) else 'Unapproved' end as \"cStatus\", (select gen from (select generate_series(cast(gp3.\"jbData\"->'joRecycle'->>'nQuantity' as decimal), cast(gp3.\"jbData\"->'joPeriod'->>'nQuantity' as decimal)) as gen) as period where gp3.\"dtAddIn\" between gp3.\"dtInit\" and (timestamptz(gp3.\"jbData\"->'joPeriod'->>'dtStartIn') + (cast(period.gen as text) || cast(gp3.\"jbData\"->'joRecycle'->>'cMeasure' as text))::interval) limit 1) as \"nCycleNumber\", * from \"default\".\"tbSummarize\" gp3 left join (select gp1.\"gdIdSummarize\" as \"gdIdWorker\", gp1.\"dtAddIn\" as \"dtAddInWorker\",gp1.\"nLengthBatch\", min(gp1.\"nCountBatch\") \"miBatch\", max(gp1.\"nCountBatch\") \"maBatch\", avg(gp1.\"nCountBatch\") \"avBatch\",gp1.\"nCountChunk\" as \"nCountChunkWorker\", sum(case \"bWorkDone\" when true then gp1.\"nCountBatch\" else 0 end) \"nChunkAdd\",min(gp1.ms_timespend) \"miWtMs\",max(gp1.ms_timespend) \"maWtMs\",avg(gp1.ms_timespend) \"avWtMs\",min(gp1.pr_timespend) \"miWtMsPr\",max(gp1.pr_timespend) \"maWtMsPr\",avg(gp1.pr_timespend) \"avWtMsPr\" from (select date_part('milliseconds', \"dtBackIn\"-\"dtRunIn\") ms_timespend ,date_part('milliseconds', justify_interval(\"dtBackIn\"-\"dtRunIn\")) / \"nCountBatch\" pr_timespend, * from \"default\".\"tbSummarizeWorker\") as gp1 group by gp1.\"gdIdSummarize\",gp1.\"dtAddIn\",gp1.\"nCountChunk\",gp1.\"nLengthBatch\") gp2 on gp2.\"gdIdWorker\" = gp3.\"gdIdEvent\" where gp3.\"nIdEnvironment\"  = {0} order by gp3.\"dtAddIn\" desc) as r;"
    }
  }
};
